import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import { useState, useEffect, useRef, useMemo, useCallback } from "react"

import { rootStore, useStores } from "stores/root-store"

import AlertDialog from "components/common/alert-dialog"
import { LoggingHelper } from "utils/logging-helper"
import { FormWrapper } from "components/common-styles"
import { errorType, trackEvent } from "utils/analytics"
import DGItemProfileInfo from "./dg-item-profile-info"
import { transformObjectKeys } from "utils/app-helper"
import CommonFormActions from "components/common/common-form-actions"
import { ArrowBack } from "@mui/icons-material"

const DGItemProfileForm = ({ onClose, onSave }) => {
  const { DGItemProfileStore } = useStores()
  const initialValues = useMemo(() => {
    return {
      item: "",
      class: "",
      packing_group: "",
      common_name: "",
      technical_name: "",
      un_number: null,
      dg_volume: null,
      receptacle_volume: null,
      flashpoint_degc: null,
      subsidary_risk: "",
      lithium_battery: "N",
      battery_weight: null,
      personal_care: "N",
      marine_pollutant: "N",
      msds_creation_date: null,
      msds_expiry_date: null,
      msds_file_name: "",
      emergency_contact_phone: "",
      emergency_contact_name: "",
      id8000: "N",
      active: "Y",
    }
  }, [])

  const [openAlert, setOpenAlert] = useState(false)
  const [alertContent, setAlertContent] = useState("")

  const formRef = useRef()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [detailInfo, setdetailInfo] = useState(initialValues)
  const [wasSuccess, setWasSuccess] = useState(true)

  const initData = useCallback(() => {
    if (DGItemProfileStore.detailInfo) {
      const data = transformObjectKeys({ ...DGItemProfileStore.detailInfo }, true)
      setdetailInfo(data)
    } else {
      setdetailInfo(initialValues)
    }
  }, [DGItemProfileStore.detailInfo, initialValues])

  useEffect(() => {
    initData()
  }, [initData])

  const handleSubmit = async () => {
    const resInfo = await formRef.current.getFormDataIfValid()
    if (!resInfo) return

    const newInfo = { ...detailInfo, ...resInfo }
    newInfo.user_name = rootStore.userName
    newInfo.active = newInfo.active == false ? "N" : newInfo.active
    newInfo.lithium_battery = newInfo.lithium_battery == false ? "N" : newInfo.lithium_battery
    newInfo.personal_care = newInfo.personal_care == false ? "N" : newInfo.personal_care
    newInfo.marine_pollutant = newInfo.marine_pollutant == false ? "N" : newInfo.marine_pollutant
    newInfo.id8000 = newInfo.id8000 == false ? "N" : newInfo.id8000

    setIsSubmitting(true)
    setOpenAlert(true)
    const result = await DGItemProfileStore.addOrUpdateData(newInfo)
    LoggingHelper.writeLog("DGItemProfileForm", "submit", `${result ? JSON.stringify(result) : ""}`)
    setIsSubmitting(false)

    setWasSuccess(true)
    let msg = DGItemProfileStore.detailInfo ? "Data Updated Successfully" : "New Data Added Successfully"
    if (result && (result.resource?.message || result.message || result["message "] || typeof result == "string")) {
      setWasSuccess(false)
      msg = result.resource?.message || result["message "] || result.message || result
      trackEvent("record_save", { entity: "dg_item_profile", mode: DGItemProfileStore.detailInfo ? "edit" : "add", result: "failed", error_type: errorType(result) })
    } else {
      trackEvent("record_save", { entity: "dg_item_profile", mode: DGItemProfileStore.detailInfo ? "edit" : "add", result: "success" })
    }
    setAlertContent(msg)
  }

  const onOK = () => {
    setOpenAlert(false)
    if (wasSuccess) {
      onSave()
    }
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <>
      <FormWrapper spacing={2}>
        <Stack direction={"row"} spacing={2}>
          <Tooltip placement="top" title="Back">
            <IconButton onClick={handleClose}>
              <ArrowBack />
            </IconButton>
          </Tooltip>

          <Box>
            {DGItemProfileStore.detailInfo ? (
              <>
                <Typography variant="h5">Edit DG Item Profile: {DGItemProfileStore.detailInfo.ITEM}</Typography>
                <small>Review attributes on an existing DG Item Profile</small>
              </>
            ) : (
              <>
                <Typography variant="h5">New DG Item Profile</Typography>
                <small>Enter attributes to create a new DG Item Profile</small>
              </>
            )}
          </Box>
        </Stack>

        <DGItemProfileInfo detailInfo={detailInfo} ref={formRef} />

        <CommonFormActions isSubmitting={isSubmitting} handleSubmit={handleSubmit} handleClose={handleClose} />
      </FormWrapper>
      <AlertDialog isProgress={isSubmitting} content={alertContent} open={openAlert} onClose={() => setOpenAlert(false)} onOK={onOK} />
    </>
  )
}

export default DGItemProfileForm
